/**
 * Scalar theme override for the API docs page — matches our public docs site
 * (dark surface, brand purple accent). Passed to ApiReferenceReact `customCss`.
 */
export const customCss = `
:root, .scalar-app {
  --scalar-color-accent: #783DF5;
  --scalar-color-1: #F0F2F6;
  --scalar-color-2: #CBD2DB;
  --scalar-color-3: #A7ADB7;
  --scalar-color-disabled: #6E727C;
  --scalar-background-1: #101112;
  --scalar-background-2: #1D1E1F;
  --scalar-background-3: #26272a;
  --scalar-border-color: #292A2D;
  --scalar-color-green: #46B73C;
  --scalar-color-red: #F40837;
  --scalar-color-yellow: #FFD700;
  --scalar-color-blue: #783DF5;
  --scalar-color-orange: #FF7F00;
  --scalar-color-purple: #783DF5;
  --scalar-button-1: #783DF5;
  --scalar-button-1-hover: #591CDD;
  --scalar-button-1-color: #FFFFFF;
  --scalar-font: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --scalar-font-code: 'JetBrains Mono', 'SF Mono', Menlo, monospace;
}
.scalar-app, .scalar-app body { background: #101112 !important; color: #F0F2F6 !important; }
/* Scalar breaks table text mid-word, which splits money figures. Only long code names may wrap. */
.markdown td, .markdown th { word-break: normal !important; }
.markdown td code, .markdown th code { word-break: break-word !important; }
`;
